import {
  IContractCustomSection,
  IContractDisplaySection,
  IContractDistributionSection,
  IContractDistributionSectionWithAmount,
  IContractResponse,
} from 'services/contract/types';

export interface IContractTreeShare {
  salesChannelId: string;
  salesChannelName: string;
  percent: number;
  amountPerUnit?: number;
}

export interface IContractTreeSection {
  id: string;
  title: string;
  position: number;
  defaultSharePercentage?: number;
  defaultAmountPerUnit?: number;
  shares?: IContractTreeShare[];
  children?: IContractTreeSection[];
}

export interface IContractTreeCustomSection {
  position: number;
  title: string;
  type: {
    name: string;
    id: number;
  };
  agreement: {
    position: number;
    title: string;
    value: string;
    mode: number;
  }[];
  customSections?: IContractTreeCustomSection[];
}

export interface IContractTreeData {
  id: string;
  title: string;
  labelName: string;
  startDate: string;
  endDate: string | null;
  status: number;
  digitalDistributionSection?: IContractTreeSection;
  physicalDistributionSection?: IContractTreeSection;
  merchDistributionSection?: IContractTreeSection;
  channelDistributionSection?: IContractTreeSection;
  costDistributionSection?: IContractTreeSection;
  customSections?: IContractTreeCustomSection[];
}

export const contractMiddleware = {
  toOrderedSections(contract: IContractResponse): IContractDisplaySection[] {
    if (!contract) return [];

    const sections: IContractDisplaySection[] = [];

    const distributions: (
      | IContractDistributionSection
      | IContractDistributionSectionWithAmount
      | null
    )[] = [
      contract.channelDistributionSection,
      contract.digitalDistributionSection,
      contract.physicalDistributionSection,
      contract.merchDistributionSection,
      contract.costDistributionSection,
    ];

    distributions
      .filter(
        (
          section,
        ): section is IContractDistributionSection | IContractDistributionSectionWithAmount =>
          Boolean(section),
      )
      .forEach((distribution) => {
        sections.push({
          type: 'distribution',
          title: distribution.title,
          position: distribution.position,
          data: distribution,
        });
      });

    if (contract.customSections?.length) {
      contract.customSections.forEach((customSection: IContractCustomSection) => {
        sections.push({
          type: 'custom',
          title: customSection.title,
          position: customSection.position,
          data: customSection,
        });
      });
    }

    return sections.sort((a, b) => a.position - b.position);
  },
};
